import { render, staticRenderFns } from "./PermissionRoleAdd.vue?vue&type=template&id=25ab1946&scoped=true&"
import script from "./PermissionRoleAdd.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab1946",
  null
  
)

export default component.exports